<template>
    <div id="app" class="home page-template-default page page-id-13 wp-custom-logo wp-embed-responsive post-image-aligned-center sticky-menu-fade sticky-enabled both-sticky-menu no-sidebar nav-below-header separate-containers header-aligned-left dropdown-hover">
        <HeadNav :selectedLanguage="selectedLanguage" page="features" :gotodownload="gotodownload" :apk="apk" />

        <div id="page" class="site grid-container container hfeed">
            <div class="markdown-content">
                <h1><strong>Features Hub – GB WhatsApp Functional Overview Center</strong></h1>


                <p>Welcome to the <strong>Features Hub</strong> — the central destination for exploring every powerful capability that GB WhatsApp brings to your messaging experience. Whether you are a new user looking to understand what makes this modded application stand out, or a long-time user wanting to discover hidden gems you have not yet tried, this hub serves as your complete guide.</p>

                <p>GB WhatsApp is not just a simple messaging application. It is a comprehensive communication toolkit that has been engineered to give users <strong>full control over their privacy, media sharing capabilities, account management, and visual personalization</strong>. The Features Hub is organized into four core functional areas, each dedicated to a specific dimension of the user experience. Every section below links directly to its detailed sub-page, where you can dive deep into individual features, step-by-step usage guides, and practical tips.</p>

                <h2>What Is the Features Hub and Why Does It Matter?</h2>

                <p>The Features Hub exists because GB WhatsApp offers a remarkably broad set of capabilities that can feel overwhelming at first glance. Rather than burying everything in a single long page, this hub breaks things down into focused areas — <a href="/features/custom-themes/">Theme System</a>, <a href="/features/privacy-control/">Privacy Control</a>, <a href="/features/media-sharing/">Media Sharing</a>, and <a href="/features/account-management/">Account Management</a> — so you can find exactly what you need without wading through irrelevant information.</p>

                <p>For users coming from the official WhatsApp application, the difference is immediately apparent. Official WhatsApp intentionally limits customization and privacy controls to maintain a one-size-fits-all experience. GB WhatsApp takes a fundamentally different approach: it opens up the entire platform to user customization, giving you the tools to make your messaging environment truly your own. This philosophy of user empowerment is at the core of every feature we detail in this hub.</p>

                <h2>The Core Value Proposition of GB WhatsApp Features</h2>

                <p>Before exploring individual feature categories, it is worth understanding the overarching value that GB WhatsApp delivers. The application is built on three pillars: <strong>freedom, privacy, and efficiency</strong>. Freedom means you can change virtually anything about the interface and behavior of the app. Privacy means you control who sees your activity, your last seen status, and your messages. Efficiency means you can manage multiple accounts, share large media files, and organize your communication in ways that official WhatsApp simply does not support.</p>

                <p>These three pillars are not marketing buzzwords — they translate directly into specific, actionable features that you will find detailed across this hub. Each feature has been designed with real-world usability in mind, meaning you do not need to be technically inclined to take advantage of everything GB WhatsApp has to offer.</p>

                <h2>Theme System – Customize Every Visual Aspect</h2>

                <p>The <a href="/features/custom-themes/">Theme System</a> section is where visual personalization lives. GB WhatsApp supports an extensive library of downloadable themes, each with its own color palette, iconography, and layout adjustments. Beyond themes, the UI customization options allow you to tweak individual elements — chat bubble colors, font styles, message font sizes, and even the overall layout structure of the app. If you want your messaging app to reflect your personality rather than WhatsApp's default design, this section is your starting point.</p>

                <p>Within the Theme System, you will also find detailed guides on chat bubble styling. Chat bubbles are one of the most frequently seen elements in any messaging app, and customizing them can transform the entire feel of your conversations. We cover everything from choosing pre-made bubble styles to creating your own color combinations for sent versus received messages.</p>

                <h2>Privacy Control – Take Command of Your Digital Footprint</h2>

                <p>Privacy is one of the most searched-for features in any messaging application, and GB WhatsApp delivers here in a major way. The <a href="/features/privacy-control/">Privacy Control</a> section covers three flagship capabilities: <strong>Hide Online Status</strong>, <strong>Freeze Last Seen</strong>, and <strong>Anti-Revoke</strong>. Each of these features addresses a specific privacy concern that users commonly face when using messaging apps.</p>

                <p>The Hide Online Status feature lets you appear offline to specific contacts or everyone, regardless of what you are actually doing in the app. Freeze Last Seen allows you to lock your last seen timestamp to a specific time, preventing others from knowing when you were last active. Anti-Revoke is particularly popular — it lets you read messages that someone has deleted after sending, which can be invaluable in group chats or important one-on-one conversations. Detailed tutorials, operational nuances, and practical application scenarios for each feature are all covered in the sub-page.</p>

                <h2>Media Sharing – Share More, Better, Faster</h2>

                <p>The <a href="/features/media-sharing/">Media Sharing</a> section addresses one of the most practical limitations of official WhatsApp: file size and media quality restrictions. GB WhatsApp dramatically extends what you can share. You can send large video files well beyond the official limit, maintain original image quality during transmission, and adjust compression settings to balance visual fidelity against data usage.</p>

                <p>This section also explores the video length capabilities of GB WhatsApp, explaining how the application handles long-form video content, what formats are supported, and how to optimize video sharing for the best recipient experience. Whether you are sharing a quick photo or a detailed video walkthrough, GB WhatsApp gives you granular control that official WhatsApp simply does not offer.</p>

                <h2>Account Management – Seamlessly Handle Multiple Identities</h2>

                <p>More and more users maintain multiple phone numbers for different aspects of their lives — work, personal, family, or specific communities. The <a href="/features/account-management/">Account Management</a> section covers GB WhatsApp's powerful multi-account support, including how to bind multiple phone numbers, quickly switch between accounts, and separate notifications so you never miss a message on the wrong account.</p>

                <p>This feature is especially valuable for small business owners, social media managers, content creators, and anyone who needs to keep their professional and personal communications cleanly separated. The account switching mechanism in GB WhatsApp is designed to be instantaneous, so you do not experience delays or friction when moving between accounts. Notification separation adds another layer of usability by allowing you to assign distinct alert sounds and vibration patterns to each account.</p>

                <h2>How to Navigate the Features Hub Effectively</h2>

                <p>Each section of this hub is self-contained and can be read independently. If you arrived here looking for a specific feature — for example, if you want to know exactly how to hide your online status — you can jump directly to the <a href="/features/privacy-control/">Privacy Control</a> sub-page and find what you need. Alternatively, if you are exploring what GB WhatsApp can do in general, reading through the hub sequentially gives you a comprehensive overview of the application's full potential.</p>

                <p>Every sub-page within the Features Hub includes practical how-to guides, usage scenarios, and answers to common questions. We recommend bookmarking the sub-pages you find most relevant so you can return to them quickly whenever you need a reminder on a specific feature's operation.</p>

                <h2>Frequently Asked Questions About GB WhatsApp Features</h2>

                <p><strong>Are GB WhatsApp features safe to use?</strong> GB WhatsApp implements privacy and customization features using the same base architecture as official WhatsApp. While no third-party mod can offer a 100% ban-free guarantee, the application has been refined over many versions to minimize risk. We recommend always downloading from the official GB Free Apk channel and keeping your version updated.</p>

                <p><strong>Do I need technical skills to use these features?</strong> No. Every feature in GB WhatsApp has been designed with accessibility in mind. The interface uses familiar WhatsApp layouts, and customization options are accessible through standard menu navigation. Detailed step-by-step guides on each sub-page make it easy for any user to get started.</p>

                <p><strong>Can I use these features simultaneously?</strong> Absolutely. The features in GB WhatsApp are largely independent of one another. You can use Hide Online Status while sharing large media files and managing two different accounts at the same time — the application handles all of these capabilities concurrently without conflict.</p>

                <p><strong>Will updating GB WhatsApp reset my feature settings?</strong> In most cases, your settings and preferences are preserved during updates. However, it is always good practice to note your custom configurations before performing a major version update, just as you would with any important application.</p>
            </div>
        </div>

        <div v-if="$global.isMobileDevice()" id="fixed-bottom-btn" class="fix-bottom-btn" @click="gotodownload()">
            Download GBWhatsApp APK
        </div>
    </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/blog/blogspc.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
    name: 'Features',
    components: { HeadNav },
    data() {
        return {
            pageName: 'features',
            selectedLanguage: 'en',
            showapk: false,
            apk: null,
            from: 'gb',
            filename: 'gb',
        };
    },
    mounted() {
        this.from = this.$global.GetQueryString('from') || this.from;
        this.filename = this.$global.GetQueryString('filename') || this.filename;
        if (this.$global.GetQueryString('from')) {
            this.getAPK();
        } else {
            this.getOfficalApk();
        }
    },
    methods: {
        getAPK() {
            this.$server.getAPPInfo({
                promotionChannel: this.from,
                promotionName: this.filename,
            }).then((res) => {
                if (res.code == 200) this.apk = res.data.apk;
                else this.apk = process.env.VUE_APP_GBLINK;
            });
        },
        getOfficalApk(type = 1) {
            this.$server.getOfficalApk({
                domain: 'gbwhatsapp.chat',
                appName: 'GB_gbwhatsapp.chat',
            }).then((res) => {
                if (res.code == 200) {
                    this.apk = res.data.apk;
                } else {
                    this.apk = process.env.VUE_APP_GBLINK;
                }
            });
        },
        gotodownload() {
            if (this.apk) this.$global.download(this.apk);
        },
    },
};
</script>

<style lang="scss" scoped>
.markdown-content {
    padding: 20px;
    line-height: 1.6;
    margin: 0 auto;
    max-width: 1000px;
}
.markdown-content h1 {
    font-size: 2em;
    margin: 0 0 0.67em;
    border-bottom: 2px solid #eee;
    padding-bottom: 0.3em;
}
.markdown-content h2 {
    font-size: 1.5em;
    margin: 0.75em 0;
    border-bottom: 1px solid #eee;
    padding-bottom: 0.3em;
}
.markdown-content h3 {
    font-size: 1.25em;
    margin: 0.83em 0;
}
.markdown-content p {
    margin: 1em 0;
}
.markdown-content ul,
.markdown-content ol {
    margin: 1em 0;
    padding-left: 2em;
}
.markdown-content li {
    margin: 0.5em 0;
}
.markdown-content img {
    width: 100%;
    height: auto;
    border-radius: 4px;
    margin: 1em 0;
}
.markdown-content a {
    color: #667eea;
    text-decoration: none;
}
.markdown-content a:hover {
    text-decoration: underline;
}
.markdown-content strong {
    font-weight: 700;
}
</style>
